import { Expose } from 'class-transformer'
import type { PeopleTagResource as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export default class PeopleTagResource implements CamelCaseKeys<Model> {
    id?: Model['id']
    oid?: Model['oid']

    @Expose({ name: 'person_id' })
    personId?: Model['person_id']

    @Expose({ name: 'tag_id' })
    tagId?: Model['tag_id']

    name?: Model['name']

    @Expose({ name: 'added_by_user_id' })
    addedByUserId?: Model['added_by_user_id']

    @Expose({ name: 'created_on' })
    createdOn?: Model['created_on']

    constructor(values: PeopleTagResource) {
        Object.assign(this, values)
    }
}
